import { render, staticRenderFns } from "./CardPersonalData.vue?vue&type=template&id=62b49076"
import script from "./CardPersonalData.vue?vue&type=script&lang=js"
export * from "./CardPersonalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b49076')) {
      api.createRecord('62b49076', component.options)
    } else {
      api.reload('62b49076', component.options)
    }
    module.hot.accept("./CardPersonalData.vue?vue&type=template&id=62b49076", function () {
      api.rerender('62b49076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Legajos/LegajoInfo/CardPersonalData.vue"
export default component.exports